<Panel p="md" bg="surface">
{#if loaded}
  <Panel>
    <Label>Seleccione la lista de puntos de control</Label>
    <Select bind:value={selectedList}>
      {#each lists as list, index}
        <option value={index}>{list.title}</option>
      {/each}
    </Select>
  </Panel>

  <Panel>
    <Label>Seleccione el tipo de datos a codificar</Label>
  </Panel>
  <Panel>
    <Button sm on:click={() => urlSelected = false}>Contenido</Button>
    <Button sm on:click={() => urlSelected = true}>Url</Button>
  </Panel>

  {#if urlSelected}
    <Panel>
      <Label>Seleccione al usuario que llenará este formulario</Label>
      <Select bind:value={selectedUser}>
        {#each usersList as user, index}
          <option value={index}>{user.names} {user.surnames}</option>
        {/each}
      </Select>
    </Panel>


    <Panel py="md">
      <Text md>
        Relacione al menos un campo del formulario al menos una columna de la lista para que se autocomplete
      </Text>
    </Panel>

    <Panel py="sm">
      <Input w="24" bind:value={baseUrl} />
    </Panel>

    <Panel flex py="sm" justify=start align="left">
      <Label w="18">Campo del formulario</Label>
      <Label w="18">Columna de la lista</Label>
    </Panel>

    {#each selectedFieldBindings as binding}
      <Panel flex py="xs" justify=start align="left">
        <Select bind:value={binding.field} maxw="18">
          {#each fieldsList as section, secIndex}
            <optgroup label={(section.label || section.property)}>
              {#each section.controls as field, conIndex}
              {#if !field.hidden}
                <option value={[secIndex,conIndex]}>{(field.label || field.alias || field.propery)}</option>
              {/if}
              {/each}
            </optgroup>
          {/each}
        </Select>
        <Select bind:value={binding.column} maxw="18" ml="sm">
          {#each listColumns as column, index}
            <option value={index}>{column.name}</option>
          {/each}
        </Select>
      </Panel>
    {/each}
  {:else}
    <Panel>
      <Label md>Seleccione las columnas de la lista</Label>
    </Panel>
    {#each selectedContent as content, contentIndex}
      <Panel py="xs">
        <Select maxw=16 bind:value={content}>
          {#each listColumns as column, lcIndex}
            <option value={[contentIndex,lcIndex]}>{column.name}</option>
          {/each}
        </Select>
      </Panel>
    {/each}
  {/if}

  <Panel py="md">
    <Text md>
      Seleccione las columnas de la lista que debieran mostrarse en las etiquetas (de las mencionadas anteriormente)
    </Text>
  </Panel>

  {#each selectedLabelData as labelData, ldIndex}
    <Panel py="xs">
      <Select bind:value={labelData}>
        {#each listColumns as column, lcIndex}
          <option value={[ldIndex,lcIndex]}>{column.name}</option>
        {/each}
      </Select>
    </Panel>
  {/each}
  
  <Button lg
    on:click={generateQRLabels}
    >
    Generar etiquetas QR
  </Button>
{/if}
</Panel>

<script>
  import { onMount, tick } from "svelte";
  import { Button, Input, Label, Panel, Select, Text } from "svelte-stylo"
  import { getListContent, getActiveUsers } from './helpers/list-helpers'
  import { getFields } from './helpers/record-def-helpers'
  import { _emptyTable, print } from './helpers/pdfmake-helpers'
  import { Account } from '@/models'

  let
    recordDefProps = null,
    lists = [],
    selectedList = 0,
    emptyColumn = [{name: "Ninguna"}],
    listColumns = emptyColumn,
    emptyField = [{label:"Sin categorizar", controls: [{label: "Ninguno"}]}],
    fieldsList = emptyField,
    usersList = [],
    selectedUser = 0,
    selectedFieldBindings = [],
    dataBindings = {},
    baseUrl = 'https://apps.treme.io/oneform/index.html#/',
    selectedLabelData = [{},{}],
    loaded = false,
    urlSelected = false,
    selectedContent = [{},{},{}],
    account = null
      
  for(let i = 0; i < 4; i++) {
    selectedFieldBindings.push(
      {field: fieldsList[0].controls[0], column: listColumns[0]}
    )
  }

  onMount(async () => {
    recordDefProps = theModel.get("record_def_props");
    lists = theModel.accountLists;
    selectedList = 0;
    fieldsList = emptyField.concat(getFields(recordDefProps)); // adds the fields on top of the empty one
    listColumns = listColumns.concat(lists[selectedList].defs.cols); // adds the list columns on top of the empty one
    usersList = await getActiveUsers();
    selectedUser = 0;
    account = await API.get('/account')
    await tick();
    loaded = true;
    await tick();
  })

  $: {
    if(lists[selectedList]) {
      listColumns = emptyColumn.concat(lists[selectedList].defs.cols)
    }
  }

  async function generateQRLabels() {
    let listContent = await getListContent(lists[selectedList])
    
    if(urlSelected) {
      let fieldBindings = selectedFieldBindings.map(binding => {
        if (!binding.field.includes(',')) return binding

        let secIndex = binding.field.split(',')[0], conIndex = binding.field.split(',')[1]
        return {
          field: fieldsList[secIndex].controls[conIndex],
          column: listColumns[binding.column]
        } 
      })
      let 
        urls = generateURLs(usersList[selectedUser],lists[selectedList],listContent,fieldBindings)

      if (urls.length != 0) {
        generateQRs(urls,listContent)
      } else {
        alert('No se seleccionaron campos necesarios')
      }
    } else {
      let 
        relevantIndexes = [],
        data = []
      
      selectedContent.forEach((listColumn) => {
        let 
          colIndex = listColumn.split(',')[1] 

        if (colIndex > 0) {
          relevantIndexes.push(colIndex - 1) // -1 because the first column is the empty one
        }
      })

      if (relevantIndexes.length) {
        listContent.data.forEach((content) => {
          let dataConcat = ''
          relevantIndexes.forEach((i) => {
            dataConcat = dataConcat + content[i] + ' '
          })
          data.push(dataConcat.trim())
        })
        generateQRs(data,listContent)
      } else {
        alert('No se seleccionaron campos necesarios')
      }
    }
  }

  function generateURLs(user,list,listContent,bindings) {
    console.log('User:', usersList[selectedUser], '\n',
            'List:', lists[selectedList], '\n',
            'Field Bindings:', bindings)
    let
      urls = [],
      params = {
        a: account.id,               
        f: recordDefProps.master_id, // form to use
        u: user.email,               // expecting the generic user email
        d: JSON.stringify({})        // bindings in pairs with actual list data {field,colData}
      }
    
    dataBindings = getDataBindings(list,listContent,bindings)
    console.log("databindings",dataBindings)

    if (dataBindings.length == 0) return []

    for(let i = 0; i < dataBindings[0].data.length; i++) { // this works but it need that all columns
      let                                                  // have the same height
        d = {},
        url = ''
      
      dataBindings.forEach((dataBinding) => {
        d[dataBinding.field.property] = dataBinding.data[i]
      })
      params.d = JSON.stringify(d)
      url = baseUrl + '?f=' + params.f +
                      '&a=' + params.a +
                      '&u=' + encodeURI(params.u) +
                      '&d=' + encodeURI(params.d)
      urls.push(url)
    }
    console.log("urls", urls)
    return urls
  }

  function getDataBindings(list,listContent,bindings) {
    let 
      dataBindings = []
    
    bindings.forEach((binding) => {
      if(binding.field != emptyField[0] && binding.column != emptyColumn[0]) { // if binding is not empty
        let 
          colIndex = list.defs.cols.findIndex(col => binding.column === col),
          dataBinding = {
            field: binding.field,
            data: []
          }
        
        listContent.data.forEach((content) => {
          dataBinding.data.push(content[colIndex])
        })
        dataBindings.push(dataBinding)
      }
    })
    return dataBindings
  }
  
  function generateQRs(toEncode,listContent) {
    let 
      height = 208.9,
      rowSize = 2,
      columnSize = 4,
      docDefinition = {
        pageBreak: 'before',
        pageMargins: [0,0,0,0],
        content: [ _emptyTable(height,columnSize) ]
      },
      row = [],
      qrSize = 130,
      contentIndex = 0,
      tableIndex = 0

    toEncode.forEach((uncoded) => {  // Populates the doc with the QRs and their labels
      let 
        obj = {
          stack: [ //empty lines to add top and bottom padding
            {text: ' ', fontSize: 15},
            {qr: uncoded, fit: qrSize, alignment: 'center'},
            {text: ' ', fontSize: 5}
          ]}

      selectedLabelData.forEach(labelData => {
        let
          colIndex = labelData.split(',')[1] - 1 // -1 because the first column is the empty one in the selector
        if (colIndex > 0) {
          obj.stack.push({
            text: listContent.data[contentIndex][colIndex],
            fontSize: 15,
            alignment: 'center',
            bold: true
          })
        }
      })

      if (row.length < rowSize) { // put urls in same sized rows
        row.push(obj)
      } else {                    // when the row is complete and there are urls left, adds them and continues
        if (docDefinition.content[tableIndex].table.body.length === columnSize) {
          docDefinition.content.push(_emptyTable(height,columnSize))
          tableIndex++
        }  
        docDefinition.content[tableIndex].table.body.push(row)
        row = []
        row.push(obj)
      }
      contentIndex++
    })

    do { // if a page wasn't complete, fills it with blanks 
      if(row.length > 0){ // there's a row left, either for completion or incompletion
        while(row.length < rowSize) {
          row.push('') //if incomplete, complete with blanks
        }
        if (docDefinition.content[tableIndex].table.body.length === columnSize) {
          docDefinition.content.push(_emptyTable(height,columnSize))
          tableIndex++
        }  
        docDefinition.content[tableIndex].table.body.push(row)
        row = ['','']  // blank row in case there are columns to fill
      } 
    } while (docDefinition.content[tableIndex].table.body.length % columnSize != 0)

    print(docDefinition)
  }

</script>